import { Checkbox, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import pluralize from 'pluralize';

import { TruLabel } from 'common/trulabel';

type Props = {
  fullCredits?: number;
  creditsToUse?: number;
  label?: string;
  size?: string;
  title?: string; // used in place of trulabel
  truSuffix?: string;
};

const strikeThroughCommon = {
  textDecoration: 'line-through',
  textDecorationThickness: '4px',
  textDecorationColor: '#8DA8B2',
};

const useStyles = makeStyles(() => ({
  title: {
    color: '#2274A5',
  },
  rowWrapper: {
    verticalAlign: 'top',
    marginTop: '5px',
    marginBottom: '5px',
  },
  pricingCheckbox: {
    paddingTop: '1px',
    color: 'black',
  },
  priceBoxWrapper: {},
  strikeThroughLg: {
    fontSize: '2.8em',
    ...strikeThroughCommon,
  },
  strikeThroughSm: {
    fontSize: '1.9em',
    ...strikeThroughCommon,
  },
  priceBox: {
    float: 'right',
    color: '#8DA8B2',
    border: '2px solid #8DA8B2',
    borderRadius: '3px',
    padding: '0px 10px 0px 10px',
    marginRight: '10px',
    boxSizing: 'border-box',
    textAlign: 'right',
  },
  truPrice: {
    float: 'right',
    color: '#23B05C',
  },
}));

export default function PricingRow({
  fullCredits,
  creditsToUse,
  label,
  size,
  title,
  truSuffix,
}: Props) {
  const classes = useStyles();
  const variant = size === 'lg' ? 'h4' : 'h6';
  const strikeThroughClass = size === 'lg' ? classes.strikeThroughLg : classes.strikeThroughSm;

  return (
    <div className={classes.rowWrapper}>
      {title ? (
        <Typography className={classes.title} variant="h4">
          {title}
        </Typography>
      ) : (
        <>
          <Checkbox
            color="primary"
            className={classes.pricingCheckbox}
            checked={true}
            disabled={size === 'lg' ? false : true}
          />
          <TruLabel size={size} suffix={truSuffix!} />
        </>
      )}

      {size === 'lg' ? (
        <Typography className={classes.truPrice} variant={variant}>
          {creditsToUse} {pluralize('credit', creditsToUse)}
        </Typography>
      ) : (
        ''
      )}
      {fullCredits ? (
        <span className={classes.priceBox}>
          <span className={strikeThroughClass}>
            <Typography variant={variant}>
              {fullCredits} {pluralize('credit', fullCredits)}
            </Typography>
          </span>
        </span>
      ) : (
        ''
      )}
      <Typography variant="caption">{label}</Typography>
    </div>
  );
}
